export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";